/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/explicit-function-return-type */
/* eslint-disable @typescript-eslint/strict-boolean-expressions */
import {Injectable} from '@angular/core';
import {ToastController, ToastOptions} from '@ionic/angular/standalone';

@Injectable({
  providedIn: 'root',
})
export class ToastService {
  constructor(private readonly toastController: ToastController) {}

  private getIconMap(color: string | undefined): string {
    const icon: any = {
      success: 'checkmark-circle-outline',
      warning: 'warning-outline',
      danger: 'alert-circle-outline',
    };
    if (!color) {
      return (color = 'success');
    }
    return icon[color];
  }

  async show(props: ToastOptions): Promise<void> {
    const toast = await this.toastController.create({
      ...props,
      keyboardClose: props?.keyboardClose ?? true,
      duration: props?.duration ?? 6000,
      position: props?.position ?? 'top',
      icon: this.getIconMap(props.color),
      buttons: [
        {
          icon: 'close-outline',
          side: 'end',
        },
      ],
    });
    await toast.present();
  }

  async showMeetingToast(props: ToastOptions): Promise<void> {
    const toast = await this.toastController.create({
      ...props,
      keyboardClose: props.keyboardClose ?? true,
      duration: props.duration ?? 6000,
      position: props.position ?? 'top',
      icon: this.getIconMap(props.color),
      cssClass: 'meeting-toaster',
      buttons: [
        {
          icon: 'close-outline',
          side: 'end',
        },
      ],
    });
    await toast.present();
  }
}
